import normalizeHostname from './normalizeHostname';

export default normalizeHostname;
